import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {RestaurantServiceService} from '../../../restaurant/restaurant-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-menu',
  templateUrl: './update-menu.component.html',
  styleUrls: ['./update-menu.component.scss']
})
export class UpdateMenuComponent implements OnInit {
  private resID: number;
  menuId;
  menuDetail: any = [];
  restid: number;
  page: number;
  constructor(
    private router: Router,
              private route: ActivatedRoute,
              private restaurantServices: RestaurantServiceService,
              private toastr: ToastrService
  ) { }

  ngOnInit() {
    debugger;
    this.restid = Number(this.route.snapshot.paramMap.get('restId'));
    this.menuId = Number(this.route.snapshot.paramMap.get('menuId'));

    console.log('resID', this.restid, 'menuID', this.menuId);
    console.log(this.menuId, this.restid);
    this.editMenu();

  }
  editMenu() {
    this.restaurantServices.getMenubyId(this.menuId).subscribe(Response => {
    this.menuDetail = Response;
    console.log('it is updation', this.menuDetail);
    });
  }
  onSubmit() {
    console.log(this.menuDetail);
        this.restaurantServices.UpdateMenu(this.menuDetail).subscribe((Data: any) => {
        if (!Data.id) {
          this.toastr.success('Menu updated...');
          this.router.navigateByUrl('/menu/' + this.restid);
        }
        console.log('database updated', Data);


        }, error => {
          this.toastr.success(error.error.Message);

        });
  }
}
